// The home and vAST heroes are always dark; give the nav dark colours while it sits over one.
function darkNavOverHero() {
    const hero = document.querySelector("#home-hero, #vast-hero");
    const nav = document.querySelector(".site-nav");
    if (!hero || !nav) {
        return;
    }
    const update = () => nav.classList.toggle("dark", hero.getBoundingClientRect().bottom > nav.offsetHeight);
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
}

function animateHeroDiagram() {
    const diagram = document.querySelector("#hero-diagram");
    if (!diagram || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
    }

    const flash = (el) =>
        el.animate(
            [{ backgroundColor: "rgba(9, 125, 191, 0.18)" }, { backgroundColor: "transparent" }],
            { duration: 900, easing: "ease-out" }
        );

    const news = [
        ["Aiera", "Earnings call transcript"],
        ["MT Newswires", "Market moving news"],
        ["EDI", "Corporate action"],
        ["MT Newswires", "Analyst rating change"],
        ["Aiera", "Investor day transcript"],
        ["EDI", "Dividend announcement"],
    ];
    let newsIndex = 3;
    const quotes = [["AAPL", 189.32], ["MSFT", 420.17], ["GOOGL", 176.43], ["NVDA", 121.44], ["AMZN", 186.51]];
    let quoteIndex = 0;

    // What each card does when a pulse reaches it.
    const updates = {
        prices(card) {
            card.querySelectorAll("[data-price]").forEach((priceEl) => {
                const price = parseFloat(priceEl.textContent) * (1 + (Math.random() - 0.5) * 0.008);
                const change = (Math.random() - 0.35) * 3;
                const changeEl = priceEl.nextElementSibling;
                priceEl.textContent = price.toFixed(2);
                changeEl.textContent = `${change >= 0 ? "▲ +" : "▼ "}${change.toFixed(2)}%`;
                changeEl.classList.toggle("text-emerald-600", change >= 0);
                changeEl.classList.toggle("text-red-500", change < 0);
                flash(priceEl.parentElement);
            });
        },
        fundamentals(card) {
            const pe = card.querySelector("[data-pe]");
            pe.textContent = (parseFloat(pe.textContent) + (Math.random() - 0.5) * 0.6).toFixed(1);
            flash(pe.parentElement);
        },
        news(card) {
            const list = card.querySelector("[data-news]");
            const [source, headline] = news[newsIndex++ % news.length];
            const item = list.lastElementChild;
            item.querySelector("span").textContent = source;
            item.lastElementChild.textContent = headline;
            list.prepend(item);
            ["just now", "4m ago", "11m ago"].forEach((time, i) => {
                list.children[i].querySelector("span:last-child").textContent = time;
            });
            flash(item);
        },
        api(card) {
            const [symbol, price] = quotes[++quoteIndex % quotes.length];
            card.querySelector("[data-symbol]").textContent = symbol;
            card.querySelector("[data-quote]").textContent = (price * (1 + (Math.random() - 0.5) * 0.008)).toFixed(2);
            flash(card.querySelector("pre"));
        },
    };

    // A pulse leaves the centre box, runs along the elbow and lands on the card's dot.
    const sendPulse = (elbow) => {
        const w = elbow.offsetWidth;
        const h = elbow.offsetHeight;
        if (!w || !h) {
            return Promise.resolve();
        }
        const left = elbow.dataset.side === "left";
        const top = elbow.dataset.edge === "top";
        // Line centres in border-box coordinates (borders are 2px).
        const cardX = left ? 1 : w - 1;
        const lineY = top ? h - 1 : 1;
        const start = [left ? w : 0, lineY];
        const corner = [cardX, lineY];
        const end = [cardX, top ? 0 : h];
        const horizontal = Math.abs(start[0] - corner[0]);
        const total = horizontal + Math.abs(end[1] - corner[1]);

        const pulse = document.createElement("span");
        pulse.className = "absolute h-2.5 w-2.5 rounded-full bg-secondary";
        pulse.style.cssText = `left:${-elbow.clientLeft - 5}px;top:${-elbow.clientTop - 5}px;box-shadow:0 0 10px 3px hsl(172 90% 40% / 0.6)`;
        elbow.append(pulse);
        const at = ([x, y]) => `translate(${x}px, ${y}px)`;
        const animation = pulse.animate(
            [
                { transform: at(start), opacity: 0 },
                { transform: at(start), opacity: 1, offset: 0.05 },
                { transform: at(corner), offset: horizontal / total },
                { transform: at(end), opacity: 1 },
            ],
            { duration: 1100, easing: "ease-in-out" }
        );
        return animation.finished.then(() => pulse.remove());
    };

    // Each line runs its own loop with a random pause, so pulses overlap at random.
    diagram.querySelectorAll("[data-flow]").forEach((elbow) => {
        const name = elbow.dataset.flow;
        const card = diagram.querySelector(`[data-card="${name}"]`);
        const tick = async () => {
            if (!document.hidden && diagram.offsetParent) {
                await sendPulse(elbow);
                updates[name](card);
            }
            setTimeout(tick, 800 + Math.random() * 3200);
        };
        setTimeout(tick, 600 + Math.random() * 2000);
    });
}

function setup() {
    darkNavOverHero();
    animateHeroDiagram();

    const circleLeft = document.querySelector(".circle-left");
    const circleRight = document.querySelector(".circle-right");
    if (!circleLeft || !circleRight || typeof anime === "undefined") {
        return;
    }

    let animation = null;
    let animationRight = null;

    const animationOnScroll = () => {
        const isLg = document.getElementById("breakpoint-lg")?.offsetParent !== null;

        if (isLg && animation) {
            const rect = circleLeft.getBoundingClientRect();

            const elementTop = rect.top;
            const elementBottom = rect.bottom;
            const windowHeight = window.innerHeight;
            if (elementBottom < 0 || elementTop > windowHeight) return;

            const visiblePx = Math.min(elementBottom + 200, windowHeight) - Math.max(elementTop + 200, 0);
            const percentVisible = visiblePx / rect.height;

            animation.seek(animation.duration * percentVisible);
            animationRight.seek(animationRight.duration * percentVisible);
        }
    };

    const setupAnimation = () => {
        const isLg = document.getElementById("breakpoint-lg")?.offsetParent !== null;
        if (isLg && window.innerWidth >= 1024) {
            animation = animation ?? anime({
                targets: ".circle-left",
                width: "65%",
                duration: 10000,
                easing: "easeInOutSine",
                autoplay: false,
                borderRadius: [
                    "40% 60% 60% 40% / 50% 50% 50% 50%",
                    "30% 70% 70% 30% / 50% 50% 50% 50%",
                ],
            });

            animationRight = animationRight ?? anime({
                targets: ".circle-right",
                width: "65%",
                duration: 10000,
                easing: "easeInOutSine",
                autoplay: false,
                borderRadius: [
                    "60% 40% 40% 60% / 50% 50% 50% 50%",
                    "70% 30% 30% 70% / 50% 50% 50% 50%",
                ],
            });

        }
        if (!isLg) {
            circleLeft.setAttribute("style", "");
            circleRight.setAttribute("style", "");
        } else {
            animationOnScroll();
        }
        document.addEventListener("scroll", animationOnScroll);
    };

    setupAnimation();
    window.addEventListener("resize", () => {
        setupAnimation();
    });
}

export default setup;
